import { combineReducers } from '@reduxjs/toolkit';
import eskatReducer from './eskatReducer';
import loanOfferSliceReducer from '../slices/loanOffer.slice';
import klarnaKosmaReducer from './klarnaKosmaReducer';
import loanApplicationSliceReducer from '../slices/loanApplication.slice';
import cardApplicationSliceReducer from '../slices/cardApplication.slice';
import globalErrorSliceReducer from '../slices/globalError.slice';
import helpPopupSliceReducer from '../slices/helpPopup.slice';
import matchedMediaSliceReducer from '../slices/matchedMedia.slice';
import intlSliceReducer from '../slices/intl.slice';
import globalModalSliceReducer from '../slices/globalModal.slice';
import cardOfferSliceReducer from '../slices/cardOffer.slice';
import { apis } from '~/store/apis/endpoints/apis';
import additionalSignerSliceReducer from '../slices/additionalSigner.slice';
import userSliceReducer from '../slices/user.slice';

const rootReducer = combineReducers({
  ...apis,
  klarnaKosma: klarnaKosmaReducer,
  eskat: eskatReducer,
  loanOffer: loanOfferSliceReducer,
  globalModals: globalModalSliceReducer,
  loanApplication: loanApplicationSliceReducer,
  cardApplication: cardApplicationSliceReducer,
  globalError: globalErrorSliceReducer,
  helpPopup: helpPopupSliceReducer,
  matchedMedia: matchedMediaSliceReducer,
  intl: intlSliceReducer,
  cardOffer: cardOfferSliceReducer,
  additionalSigner: additionalSignerSliceReducer,
  user: userSliceReducer,
});

export default rootReducer;
